import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";

import { Breadcrumbs, ScreenContent, ScreenHeader, TabNavigation } from "@/ui";

const OpenAiLayout = () => {
  const { id } = useParams({ strict: false });

  return (
    <>
      <ScreenHeader>
        <Breadcrumbs
          items={[
            { label: "Integrations", to: "/integrations" },
            { label: "OpenAI", to: "/integrations/open-ai/prompts" },
            ...(id
              ? [
                  {
                    label: `#${id}`,
                    to: "/integrations/open-ai/prompts/$id",
                    params: { id },
                  } as const,
                ]
              : []),
          ]}
        />
      </ScreenHeader>

      <ScreenContent>
        <TabNavigation tabs={[{ name: "Prompts", to: "/integrations/open-ai/prompts" }]} />

        <div className="pt-4">
          <Outlet />
        </div>
      </ScreenContent>
    </>
  );
};

export const Route = createFileRoute("/_private/integrations/open-ai")({
  component: OpenAiLayout,
});
